import React from "react";
import { CloseOutlined } from "@ant-design/icons";

export const TAG_COLORS = [
  { bg: "#E8F5E9", text: "#2E7D32", dot: "#66BB6A" }, // green
  { bg: "#E3F2FD", text: "#1565C0", dot: "#42A5F5" }, // blue
  { bg: "#FFF3E0", text: "#E65100", dot: "#FFA726" }, // orange
  { bg: "#F3E5F5", text: "#7B1FA2", dot: "#AB47BC" }, // purple
  { bg: "#FFEBEE", text: "#C62828", dot: "#EF5350" }, // red
  { bg: "#E0F7FA", text: "#00695C", dot: "#26A69A" }, // teal
  { bg: "#F9FBE7", text: "#827717", dot: "#C0CA33" }, // lime
  { bg: "#FCE4EC", text: "#AD1457", dot: "#EC407A" }, // pink
  { bg: "#EDE7F6", text: "#311B92", dot: "#7C4DFF" }, // deep purple
  { bg: "#FFF8E1", text: "#F57F17", dot: "#FFB300" }, // amber
];

export const hashColor = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return TAG_COLORS[Math.abs(hash) % TAG_COLORS.length];
};

const TagPill = ({ name, onRemove, size }) => {
  const c = hashColor(name);
  const sm = size === "sm";

  return (
    <span
      className="inline-flex items-center rounded-full font-medium transition-all duration-150"
      style={{
        backgroundColor: c.bg,
        color: c.text,
        border: `1px solid ${c.dot}40`,
        padding: sm ? "0 6px" : "1px 8px",
        fontSize: sm ? 11 : 12,
        lineHeight: sm ? "18px" : "20px",
        gap: sm ? 2 : 4,
        cursor: onRemove ? "default" : "default",
      }}
    >
      <span
        className="rounded-full flex-shrink-0"
        style={{
          width: sm ? 5 : 6,
          height: sm ? 5 : 6,
          backgroundColor: c.dot,
        }}
      />
      {name}
      {onRemove && (
        <span
          onClick={(e) => { e.stopPropagation(); onRemove(name); }}
          className="inline-flex items-center justify-center rounded-full cursor-pointer transition-colors hover:bg-black/10"
          style={{ width: sm ? 12 : 14, height: sm ? 12 : 14 }}
        >
          <CloseOutlined style={{ fontSize: sm ? 7 : 8 }} />
        </span>
      )}
    </span>
  );
};

export default TagPill;
